import React, { useState } from 'react';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import {
  STACK_CENTER_COLUMN_DIRECTION,
  STACK_CENTER,
  INFORMATION_STACK_NO_BORDER,
} from '../../constants/mui-components';
import {
  fingoStepsContainer,
  titleTypography,
  subtitleTypography,
  stepperContainer,
  stepperContent,
  stepCard,
} from './styles/fingo-steps.styles';
import RegisterButton from '../../components/buttons/RegisterButton';
import InformationStack from '../../components/stacks/InformationStack';
import fingoStepsData from '../../constants/home/fingo-steps';
import VerticalStepper from '../../components/steppers/VerticalStepper';
import useGetCountry from '../../helpers/useGetCountry';
import StepCard from './components/StepCard';

function FingoSteps() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const country = useGetCountry();
  const countryFingoStepsMapper = {
    Chile: fingoStepsData.chileStepsInfo,
    Mexico: fingoStepsData.mexicoStepsInfo,
  };
  const countryFingoSteps = countryFingoStepsMapper[country];
  const handleClick = (index) => {
    if (index === activeStep) return;
    setActiveStep(index);
  };
  return (
    <Stack className={STACK_CENTER} sx={fingoStepsContainer}>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} gap="1.5rem">
        <InformationStack
          className={INFORMATION_STACK_NO_BORDER}
          text={fingoStepsData.stackText}
          backgroundColor={theme.palette.primary.A700}
          textColor={theme.palette.common.white}
          variant="info_stack"
          fontWeight={800}
        />
        <Stack className={STACK_CENTER}>
          <Typography variant="xlarge_2" sx={titleTypography(theme)}>
            {fingoStepsData.titleText}
          </Typography>
          <Typography variant="medium_2" sx={subtitleTypography(theme)}>
            {fingoStepsData.subtitleText}
          </Typography>
        </Stack>
        <RegisterButton />
      </Stack>
      <Stack className={STACK_CENTER} sx={stepperContainer}>
        <Stack sx={stepperContent}>
          <VerticalStepper
            steps={countryFingoSteps}
            activeStep={activeStep}
            handleClick={handleClick}
            staticMode={false}
            iconSize="2.8rem"
          />
          <Card sx={stepCard}>
            {countryFingoSteps.map((step) => (
              <StepCard key={step.id} step={step} activeStep={activeStep} />
            ))}
          </Card>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default FingoSteps;
